(function () {
  function initSwiper(section) {
    var el = section.querySelector('.et-ts__swiper');
    if (!el || el.hasAttribute('data-et-ts-swiper')) return;
    el.setAttribute('data-et-ts-swiper', '');

    var options = {
      slidesPerView: parseFloat(el.dataset.slidesMobile) || 1.1,
      spaceBetween: 16,
      breakpoints: {
        750: { slidesPerView: 3 },
        990: { slidesPerView: parseFloat(el.dataset.slidesDesktop) || 4 }
      }
    };

    var prev = section.querySelector('.et-ts__arrow--prev');
    var next = section.querySelector('.et-ts__arrow--next');
    if (prev && next) {
      options.navigation = { prevEl: prev, nextEl: next };
    }

    var dots = section.querySelector('.et-ts__dots');
    if (dots) {
      options.pagination = { el: dots, clickable: true };
    }

    new Swiper(el, options);
  }

  /* Show the read-more toggle only when the clamped text actually overflows */
  function initReadMore(section) {
    section.querySelectorAll('[data-et-ts-readmore]').forEach(function (button) {
      var text = button.parentElement.querySelector('[data-et-ts-text]');
      if (!text) return;

      if (text.scrollHeight > text.clientHeight + 1) {
        button.hidden = false;
      }

      button.addEventListener('click', function () {
        var expanded = text.classList.toggle('is-expanded');
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
      });
    });
  }

  function initAddButtons(section) {
    section.querySelectorAll('[data-et-ts-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart(btn.dataset.variantId, btn);
      });
    });
  }

  function addToCart(variantId, btn) {
    var id = parseInt(variantId, 10);
    if (!id || btn.disabled) return;
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var toggle = document.getElementById('cart-drawer-toggle');
        if (toggle) toggle.click();
      })
      .catch(function () {})
      .finally(function () {
        btn.disabled = false;
      });
  }

  function initSection(section) {
    if (section.hasAttribute('data-et-ts-init')) return;
    section.setAttribute('data-et-ts-init', '');
    initReadMore(section);
    initAddButtons(section);
    whenSwiperReady(function () {
      initSwiper(section);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.et-ts').forEach(initSection);
  }

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList && event.target.classList.contains('et-ts')) {
      initSection(event.target);
    } else if (event.target.querySelector('.et-ts')) {
      initAll(event.target);
    }
  });
})();
